import { FC } from 'react'
import { SvgIconComponent } from '@mui/icons-material'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined'
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import { Chip } from '@mui/material'

import { NEUTRAL_GREY_500, TILE_TEXT } from '@/common/constants'
import { SpatialPolicy } from '@/models/spatialPolicy'

import { PolicyStatus } from '../../utils/types'

interface StatusLook {
  background: string
  color: string
  Icon: SvgIconComponent
}

/**
 * The icons are the same as the old `PolicyStatusIcon`. Every color pair has a contrast ratio
 * above 6:1, so the text passes WCAG AA at the chip's small size.
 */
const STATUS_LOOK: Record<PolicyStatus, StatusLook> = {
  saved: { background: '#F0F0F0', color: NEUTRAL_GREY_500, Icon: ArchiveOutlinedIcon },
  published: { background: '#E7F3F6', color: TILE_TEXT, Icon: PublicOutlinedIcon },
  expired: { background: '#FFF4E5', color: '#8A4600', Icon: TimerOutlinedIcon },
}

/**
 * The policy status next to the policy name: Saved, Published or Expired. The old UI shows it as
 * the "Policy Status" field of the form.
 */
export const PolicyStatusChip: FC<{ policy: SpatialPolicy }> = ({ policy }) => {
  const { background, color, Icon } = STATUS_LOOK[policy.status]

  return (
    <Chip
      data-testid="policy-status-chip"
      icon={<Icon />}
      label={policy.statusText}
      size="small"
      sx={{
        background,
        color,
        flexShrink: 0,
        fontWeight: 600,
        '& .MuiChip-icon': { color: 'inherit' },
      }}
    />
  )
}
